import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 radius-7 bg-white sales-pos-location-box" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_3 = { class: "mb-15 mb-sm-0 d-sm-flex align-items-center justify-content-between" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "fw-medium text-muted fs-13 d-block mb-5 text-uppercase" }, " Gravações do ano ", -1)
const _hoisted_6 = { class: "card-title fw-black mb-0" }
const _hoisted_7 = {
  id: "weeklySalesChart",
  class: "chart mt-20"
}
const _hoisted_8 = { class: "justify-content-around mt-20 row p-10" }
const _hoisted_9 = { class: "metric-dashboard-year-graphic-information radius-7 bg-primary mb-10 col-12 col-sm-12 col-lg-3 col-xl-3 col-xxl-3 col-xxxl-3" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "ph ph-check-circle" }, null, -1)
const _hoisted_11 = { class: "metric-dashboard-year-graphic-information radius-7 bg-danger mb-10 col-12 col-sm-12 col-lg-3 col-xl-3 col-xxl-3 col-xxxl-3" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "ph ph-warning-circle" }, null, -1)
const _hoisted_13 = { class: "metric-dashboard-year-graphic-information radius-7 bg-success col-12 col-sm-12 col-lg-3 col-xl-3 col-xxl-3 col-xxxl-3" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("i", { class: "ph ph-clock-countdown" }, null, -1)
const _hoisted_15 = { class: "justify-content-around mt-20 row p-10" }
const _hoisted_16 = { class: "metric-dashboard-year-graphic-information radius-7 bg-info mb-10 col-12 col-sm-12 col-lg-3 col-xl-3 col-xxl-3 col-xxxl-3" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("i", { class: "ph ph-soundcloud-logo" }, null, -1)
const _hoisted_18 = { class: "metric-dashboard-year-graphic-information radius-7 bg-mini-green mb-10 col-12 col-sm-12 col-lg-3 col-xl-3 col-xxl-3 col-xxxl-3" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("i", { class: "ph ph-cloud-sun" }, null, -1)
const _hoisted_20 = { class: "metric-dashboard-year-graphic-information radius-7 bg-dark mb-10 col-12 col-sm-12 col-lg-3 col-xl-3 col-xxl-3 col-xxxl-3" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("i", { class: "ph ph-cloud-moon" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("h4", _hoisted_6, _toDisplayString(_ctx.getDashboardYearCards.date), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_apexchart, {
          type: "area",
          height: "375",
          options: _ctx.weeklySalesChart,
          series: [
            {
              name: 'UPLOADS COM SUCESSO', 
              data: Object.values(_ctx.getDashboardYearTable).map(month => month.total_success)
            },
            {
              name: 'UPLOADS COM ERRO', 
              data: Object.values(_ctx.getDashboardYearTable).map(month => month.total_error)
            },
          ]
        }, null, 8, ["options", "series"])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createTextVNode(" Uploads com sucesso: " + _toDisplayString(_ctx.getDashboardYearCards.total_success), 1)
        ]),
        _createElementVNode("div", _hoisted_11, [
          _hoisted_12,
          _createTextVNode(" Uploads com erro: " + _toDisplayString(_ctx.getDashboardYearCards.total_error), 1)
        ]),
        _createElementVNode("div", _hoisted_13, [
          _hoisted_14,
          _createTextVNode(" Tempo total: " + _toDisplayString(_ctx.convertTime(_ctx.getDashboardYearCards.total_time)), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _hoisted_17,
          _createTextVNode(" Tamanho total: " + _toDisplayString((_ctx.getDashboardYearCards.total_size / (1024 * 1024)).toFixed(2) + " MB"), 1)
        ]),
        _createElementVNode("div", _hoisted_18, [
          _hoisted_19,
          _createTextVNode(" AM: " + _toDisplayString(_ctx.getDashboardYearCards.am), 1)
        ]),
        _createElementVNode("div", _hoisted_20, [
          _hoisted_21,
          _createTextVNode(" PM: " + _toDisplayString(_ctx.getDashboardYearCards.pm), 1)
        ])
      ])
    ])
  ]))
}